import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RotatingLogo from "../../Loaders/RotatingLogo";
import { BiMoon, BiSun } from "react-icons/bi";
import { CiMonitor } from "react-icons/ci";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";

const LanguageStep = ({
    handleStep,
    soundClick,
    error,
    loadingSteps
}) => {
    const { t, changeLanguage } = useLanguage()
    const [languageType, setLanguageType] = useState(() => {
        const saved = localStorage.getItem("e8_language");
        return saved ? saved : "en";
    });

    const clickAction = (lan) => {
        soundClick()
        setLanguageType(lan)
        changeLanguage(lan);
    }

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.language.title}</p>
                    <p className="step_description fade-in">{t.onboarding.language.subtitle}</p>
                    <div className="experience_cont">
                        <button className={`experience_cont_choise fade-in ${languageType == "en" && "experience_cont_choise_selected"}`} onClick={() => clickAction("en")}>
                            <span>English</span>
                        </button>
                        <button className={`experience_cont_choise fade-in ${languageType == "it" && "experience_cont_choise_selected"}`} onClick={() => clickAction("it")}>
                            <span>Italiano</span>
                        </button>
                    </div>
                    <p className="pricing_info_mex fade-in">{t.onboarding.language.warning}</p>
                </div>
            </div>
            <div className="steps_btn_cont">
                <button className="steps_btn fade-in" onClick={() => handleStep("back", "welcome")}>
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>
                <div>
                    <ErrorMessage err={error} />
                </div>
                <button className="steps_btn fade-in" onClick={() => handleStep("continue", "experience")}>
                    {loadingSteps ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div>
    )
}

export default LanguageStep